// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";

import { RtwFormForm } from "./rtw-form-form";
import type { RtwFormQuestion } from "@modules/service/reducer/rtw/types";

type OwnProps = $Exact<{
  data: ?Array<RtwFormQuestion>,
  schema: Object,
  disabled?: boolean,
  onChange?: (data: Array<RtwFormQuestion>) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export const RtwFormView = (props: Props) => {
  const { data, ...rest } = props;

  return (
    <RtwFormForm
      {...rest}
      data={data.formQuestions}
      schema={(props.schema || {}).properties.formQuestions.items}
      disabled={true}
    />
  );
};

export default localize()(RtwFormView);
